module.exports = __webpack_public_path__ + "img/learn-icon-arrow-down.5c8c7d48.svg";